var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgListGray = function SvgListGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_6",
    height: 13,
    width: 62,
    y: 0,
    x: 0,
    stroke: "#e1e8e6",
    fill: "#e1e8e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_7",
    height: 13,
    width: 62,
    y: 23,
    x: 0,
    stroke: "#e1e8e6",
    fill: "#e1e8e6"
  }))));
};

export { SvgListGray as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjIiIGhlaWdodD0iMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8ZyBpZD0iTGF5ZXJfMSI+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxyZWN0IGlkPSJzdmdfNiIgaGVpZ2h0PSIxMyIgd2lkdGg9IjYyIiB5PSIwIiB4PSIwIiBzdHJva2U9IiNlMWU4ZTYiIGZpbGw9IiNlMWU4ZTYiLz4KICA8cmVjdCBpZD0ic3ZnXzciIGhlaWdodD0iMTMiIHdpZHRoPSI2MiIgeT0iMjMiIHg9IjAiIHN0cm9rZT0iI2UxZThlNiIgZmlsbD0iI2UxZThlNiIvPgogPC9nPgo8L3N2Zz4=";